import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';

const GettingStartedGoogleMap = _.flowRight(
  withScriptjs,
  withGoogleMap,
)(props => (
  <GoogleMap
    ref={props.onMapLoad}
    defaultZoom={10}
    defaultCenter={props.defaultCenter}
    onClick={props.onMapClick}
    defaultOptions={{
      mapTypeId: "satellite",
      scrollwheel: false,
    }}
  >
    {props.markers.map((marker, index) => (
      <Marker
        {...marker}
        onRightClick={() => props.onMarkerRightClick(index)}
      />
    ))}
  </GoogleMap>
));

const propTypes = {
  lat: PropTypes.string,
  lng: PropTypes.string
};

const defaultProps = {
  body: {},
  lat: 0,
  lng: 0
};

class LocationMap extends React.Component {

  render() {

    const initialCenter = {
        lat: parseFloat(this.props.lat),
        lng: parseFloat(this.props.lng),
    }

    let markers = [
      {
        position: initialCenter,
        key: "Key",
        defaultAnimation: 2,
      }
    ]

    const mapsApi = `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${GM_JS_API_KEY}`

    return (
        <div className="bg-fff mtb-30" style={{padding: '5px', height: 410 }}>
            <div style={{height: '100%' }}>
              <div style={{ width: '100%', height: '400px', position: 'static' }}>
                <div style={{width: '100%', height: '100%', position: 'relative' }} >
                  <iframe
                    style={{ width: '100%', height: '100%', border: 0 }}
                    scrolling="no"
                    src={`https://www.google.com/maps/embed/v1/view?&center=${initialCenter.lat},${initialCenter.lng}&zoom=10&maptype=satellite&key=${GM_EM_API_KEY}`}
                  />
                </div>
              </div>
              {/*
              <GettingStartedGoogleMap
                googleMapURL={mapsApi}
                loadingElement={
                  <div style={{ height: `100%` }}>
                    Loading
                  </div>
                }
                containerElement={
                  <div style={{ width:'100%', height:'400px', position:'static'}} />
                }
                mapElement={
                  <div style={{width: '100%', height: '100%', position: 'relative'}} />
                }
                onMapLoad={_.noop}
                onMapClick={_.noop}
                markers={markers}
                onMarkerRightClick={_.noop}
                defaultCenter={initialCenter}
              />
              */}
            </div>
        </div>
    );
  }
}

LocationMap.propTypes = propTypes;
LocationMap.defaultProps = defaultProps;

export default LocationMap;
